// Single source of truth for app version.
// Updated automatically by: npm run version:patch / minor / major
// Read by AdminPill and deploy scripts.

export const VERSION = '1.1.13';
export const BUILD_DATE = '2026-05-12';
export const APP_NAME = 'SheetShed';

export default { VERSION, BUILD_DATE, APP_NAME };
